import { ArrowRight, Sparkles } from "lucide-react";
import { IMAGES } from "@/lib/brand";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 sm:pt-32 pb-20 sm:pb-28 overflow-hidden"
    >
      {/* Warm radial glows — premium ambient depth */}
      <div
        aria-hidden="true"
        className="absolute -top-40 -right-40 w-[48rem] h-[48rem] rounded-full opacity-50 blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, #D7B899 0%, transparent 70%)" }}
      />
      <div
        aria-hidden="true"
        className="absolute top-1/2 -left-48 w-[36rem] h-[36rem] rounded-full opacity-30 blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, #F5E6D3 0%, transparent 70%)" }}
      />

      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-12">
        <div className="grid lg:grid-cols-12 items-center gap-y-14 lg:gap-x-12">
          {/* TEXT — 5 columns, comfortable reading width */}
          <div className="order-2 lg:order-1 lg:col-span-5 space-y-7">
            <div className="kv-badge inline-flex" data-testid="hero-badge">
              <Sparkles size={14} strokeWidth={1.5} />
              <span className="whitespace-nowrap">Spray tan organic premium</span>
            </div>

            <h1
              data-testid="hero-title"
              className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-[5.25rem] leading-[1.02] tracking-tight text-[#3B2A22]"
            >
              Obține{" "}
              <em className="italic font-normal text-[#B88746]">bronzul</em> perfect
              <span className="block mt-1">fără UV.</span>
            </h1>

            <p className="text-base sm:text-lg leading-relaxed text-[#3B2A22]/75 max-w-xl">
              Spray tan organic cu produse profesionale Norvell și Sjolie pentru un bronz
              uniform, natural și sigur — gândit pentru tenul și ritmul tău.
            </p>

            <div className="flex flex-wrap items-center gap-4 pt-2">
              <a
                href="#rezervare"
                data-testid="hero-cta-primary"
                className="btn-primary"
              >
                Programează-te acum <ArrowRight size={16} strokeWidth={1.8} />
              </a>
              <a
                href="#servicii"
                data-testid="hero-cta-secondary"
                className="btn-secondary"
              >
                Vezi serviciile
              </a>
            </div>

            <div className="flex items-center gap-6 sm:gap-8 pt-6">
              <div>
                <div className="font-serif text-3xl text-[#3B2A22]">7–10</div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#8A6E59] mt-1">
                  Zile rezistență
                </div>
              </div>
              <div className="w-px h-12 bg-[#D7B899]" />
              <div>
                <div className="font-serif text-3xl text-[#3B2A22]">100%</div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#8A6E59] mt-1">
                  Fără UV
                </div>
              </div>
              <div className="w-px h-12 bg-[#D7B899]" />
              <div>
                <div className="font-serif text-3xl text-[#3B2A22]">2</div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#8A6E59] mt-1">
                  Branduri premium
                </div>
              </div>
            </div>

            {/* Secondary trust line — Norvell · Sjolie, no longer overlapping image */}
            <div
              data-testid="hero-trust-badge"
              className="inline-flex items-center gap-3 pt-4 text-[11px] uppercase tracking-[0.28em] text-[#8A6E59]"
            >
              <span className="h-px w-10 bg-[#D7B899]" />
              <span>
                Produse profesionale{" "}
                <span className="text-[#3B2A22] font-medium">Norvell · Sjolie</span>
              </span>
            </div>
          </div>

          {/* IMAGE — 7 columns, dominant, bleeds to the right edge with feathered left edge */}
          <div className="order-1 lg:order-2 lg:col-span-7 relative w-full lg:-mr-12 xl:-mr-[max(3rem,calc((100vw-1400px)/2+3rem))]">
            <div
              className="relative img-zoom overflow-hidden bg-transparent rounded-[2rem] lg:rounded-l-[3rem] lg:rounded-r-none"
              style={{
                WebkitMaskImage:
                  "linear-gradient(to right, transparent 0%, black 12%, black 100%)",
                maskImage:
                  "linear-gradient(to right, transparent 0%, black 12%, black 100%)",
              }}
            >
              <img
                src={IMAGES.hero}
                alt="Model feminin cu bronz natural și luminos"
                className="w-full h-[560px] sm:h-[640px] lg:h-[720px] object-cover object-center block"
                data-testid="hero-image"
              />
            </div>

            {/* Soft warm shadow beneath the image for premium grounding */}
            <div
              aria-hidden="true"
              className="hidden lg:block absolute -bottom-10 left-24 right-12 h-28 blur-3xl opacity-40 pointer-events-none"
              style={{ background: "radial-gradient(ellipse at center, #B88746 0%, transparent 70%)" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
